module.exports = __webpack_public_path__ + "static/jol-forsida-loop-2d327ec60de96bbcc1b41445cf8fa60c.mp4";